import { isNull } from "App/utils/helpers";
import { useContext, useEffect, useState } from "react";
import { useMutation } from "react-query";
import { FormContext } from "../../context/FormContext";
import { getAllRikjangByKelas } from "../TabRikjang/DaftarRikjang/helpers";
import { itSelfEmpty } from "utils/all";

const RESET_STATE_FORM_FILTER_JASA = {
  pages: 1,
  limit: 10,
  kelas_id: "",
  asuransi_id: "",
  name: "",
};

const refetchRikjangByKelas = async (variables) => {
  if (!isNull(variables.kelas_id) && !isNull(variables.asuransi_id) && !isNull(variables.id_gudang)) {
    const response = await getAllRikjangByKelas(
      {
        kelas_id: variables.kelas_id,
        asuransi_id: variables.asuransi_id,
        name: variables.name,
        id_gudang: variables.id_gudang,
      },
      variables.pages,
      variables.limit
    );
    return {
      data: response.data,
      meta: response.meta,
    };
  } else {
    return {
      data: [],
      meta: {
        count: 0,
        pages: 1,
        limit: 10,
      },
    };
  }
};

export const useDaftarRikjangByKelas = () => {
  const { formData } = useContext(FormContext);
  const [formFilterRikjangByKelas, setFormFilterRikjangByKelas] = useState(
    RESET_STATE_FORM_FILTER_JASA
  );

  const rikjangs = useMutation({
    mutationFn: (variables) => {
      return refetchRikjangByKelas(variables);
    },
  });

  const rowsRikjangByKelas = isNull(rikjangs.data) ? [] : rikjangs.data.data;
  const totalDataRikjangByKelas = isNull(rikjangs.data)
    ? 0
    : rikjangs.data.meta.count;
  const loadingRikjangByKelas = rikjangs.isLoading;

  const setNewDataRikjangByKelas = (
    pages = formFilterRikjangByKelas.pages,
    limit = formFilterRikjangByKelas.limit,
    formFilter = formFilterRikjangByKelas
  ) => {
    rikjangs.mutate({
      pages,
      limit,
      kelas_id: formData.kelas_id,
      asuransi_id: formData.asuransi_id,
      name: formFilter.name,
      id_gudang: itSelfEmpty(formData.gudang_id),
    });
  };

  useEffect(() => {
    (async () => {
      await setNewDataRikjangByKelas();
    })();
  }, [formData.gudang_id, formData.kelas_id, formData.asuransi_id ]); // eslint-disable-line react-hooks/exhaustive-deps

  return {
    loadingRikjangByKelas,
    setNewDataRikjangByKelas,
    rowsRikjangByKelas,
    totalDataRikjangByKelas,
    formFilterRikjangByKelas,
    setFormFilterRikjangByKelas,
  };
};
